import { render, staticRenderFns } from "./Commentedit.vue?vue&type=template&id=50c7bfc4&"
import script from "./Commentedit.vue?vue&type=script&lang=js&"
export * from "./Commentedit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports